import { EInvestmentLength } from '@common/enums';
import { BitfStrapiModel } from '@common/libs/bitforce/core/models/strapi/bitf-strapi.model';

export class InvestmentDuration extends BitfStrapiModel {
  length: EInvestmentLength;

  constructor(data?: any) {
    super({
      data,
      hydrateProperties: {},
      serializeProperties: [],
    });
  }
}
export const allInvestmentDurations = [
  EInvestmentLength.MONTHS_6,
  EInvestmentLength.YEARS_1,
  EInvestmentLength.YEARS_2,
  EInvestmentLength.YEARS_3,
];
